import axios from "axios";
import { base_url } from "../../../constants/routes";

export function saveDriver(driver) {
  return axios
    .post(base_url + "/driver", driver)
    .then((res) => {
      return res.data;
    })
    .catch((err) => {
      console.log(err);
    });
}

export function findAllDriver() {
  return axios
    .get(base_url + "/driver")
    .then((res) => {
      console.log(res.data);
      return res.data;
    })
    .catch((err) => {
      console.log(err);
      return [];
    });
}

export function updateDriver(query, update) {
  return axios
    .put(base_url + "/driver" + "/" + query._id, update)
    .then((res) => {
      return res.data;
    })
    .catch((err) => {
      console.log(err);
    });
}

export function deleteDriver(query) {
  return axios
    .put(base_url + "/driver" + "/" + query._id, { isDeleted: true })
    .then((res) => {
      return res.data;
    })
    .catch((err) => {
      console.log(err);
    });
}
